export const encryptToSha256 = async (message) => {
  // it doesn't works with http (locally)
  try {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map((b) => ('00' + b.toString(16)).slice(-2)).join('');
  } catch (error) {
    // console.error('encryptToSha256', error);
    return `SHA256_HASH: from "${message}"`;
  }
};
